import { WORKSHOP } from "@/config/workshop";

const ITEMS = [
  `Kostenfreie Stornierung bis ${WORKSHOP.cancelFreeUntilShort}`,
  `Maximal ${WORKSHOP.capacityMax} Teilnehmer`,
  "Persönliche Rückmeldung noch am selben Tag",
];

export function CtaTrust({ className = "" }) {
  return (
    <ul className={`cta-trust ${className}`.trim()} data-testid="cta-trust">
      {ITEMS.map((item) => (
        <li key={item}>
          <span className="tick" aria-hidden="true">✓</span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
